import { FlexGrid, FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { CellType } from '@grapecity/wijmo.grid';
import { CollectionView } from '@grapecity/wijmo';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRestApi } from 'context/RestApiContext';
import StatusLableComponent from 'components/Input/StatusLableComponent';
import { useApprovalRejectCommentModal } from 'views/Approval/ApprovalRejectCommentModalContext';
import { PrintDateModal } from 'components/modal/PrintDateModal';

function QuoteInfo(props) {
  const restApi = useRestApi();
  const location = useLocation();
  const navigate = useNavigate();
  // 却下コメントモーダル
  const approvalRejectCommentModal = useApprovalRejectCommentModal();

  // パラメタ
  const quoteList = props.quoteList; // 見積り一覧
  const selectedSeikyuNo = props.selectedSeikyuNo; // 請求NO
  const setContractModalParam = props.setContractModalParam; // 契約ダイアログのパラメタ
  const clientInfo = props.clientInfo; // 顧客情報
  const contractList = props.contractList; // 契約一覧
  const callback = props.callback; // 再読み込みコールバック

  // グリッド
  const quoteGrid = useRef();

  // 見積日選択モーダルのパラメタ
  const [printDateParams, setPrintDateParams] = useState({});

  // 契約済以外も表示のチェックボックス
  const [checkedDisplayNotContract, setCheckedDisplayNotContract] = useState(false);
  // 表示中の見積もり一覧
  const [viewQuoteList, setViewQuoteList] = useState(new CollectionView(quoteList));

  // 見積一覧、契約以外表示チェックボックスの変更処理
  useEffect(() => {
    // 契約済以外を表示/非表示を制御
    let _viewQuoteList = [
      ...quoteList.filter(
        (x) => contractList.length == 0 || checkedDisplayNotContract || x.STATUS == '契約済'
      ),
    ];
    const collectionView = new CollectionView(_viewQuoteList.map((x, i) => ({ ...x, NO: i + 1 })));
    setViewQuoteList(collectionView);
  }, [quoteList, checkedDisplayNotContract]);

  // 見積の新規作成
  const handleOnClickNewQuote = () => {
    navigate('/admin/CustomerQuoteEntry', {
      state: {
        mode: 'add',
        clientId: location?.state?.clientId,
        seikyuNo: selectedSeikyuNo,
        quoteNo: 0,
        backPage: location?.pathname,
      },
    });
  };

  // 見積編集・削除
  const handleOnClickEditQuote = (mode, item) => {
    navigate('/admin/CustomerQuoteEntry', {
      state: {
        mode: mode,
        clientId: location?.state?.clientId,
        seikyuNo: selectedSeikyuNo,
        quoteNo: item.QUOTE_NO,
        backPage: location?.pathname,
      },
    });
  };

  // 見積書の印刷・ダウンロード（見積日を選択してから実行する）
  const handleQuoteAction = (item, printFlg) => {
    setPrintDateParams({
      mitsuDate: item.MITSU_DATE,
      callBack: (mitsuDate) => execQuoteAction(item, printFlg, mitsuDate),
    });
  };

  // 見積書の印刷・ダウンロードの実行
  const execQuoteAction = (item, printFlg, mitsuDate) => {
    const isWide = item?.QUOTE_FORMAT_TYPE === 1;
    const basePath = isWide ? '/api/quote/report/' : '/api/quote/vertical/report/';
    const fileName = `${isWide ? '見積書横' : '見積書縦'}_${item.QUOTE_NO}.xlsx`;
    // 見積日が変わった場合はDBも更新されるため一覧を再読み込みする
    const successCallBack = () => {
      if (mitsuDate != item.MITSU_DATE && callback) {
        callback();
      }
    };

    if (printFlg) {
      restApi.postToPdf(`${basePath}${item.QUOTE_NO}`, { printFlg, mitsuDate }, successCallBack);
    } else {
      restApi.postDownload(
        `${basePath}${item.QUOTE_NO}`,
        { printFlg, mitsuDate },
        fileName,
        successCallBack
      );
    }
  };

  // 契約作成・新規
  const handleOnClickEditContract = (item) => {
    setContractModalParam({
      mode: 'add',
      client: {
        CLIENT_CD: clientInfo['CLIENT_CD'],
        CLIENT_NAME: `${clientInfo['NAME_SEI_1']} ${clientInfo['NAME_MEI_1']}`,
        CLIENT_ADD: `${clientInfo['PREF']}${clientInfo['CITY']}${clientInfo['TOWN']}${clientInfo['ADDRESS']}`,
      },
      quote: item,
    });
  };

  // 見積もり明細のアイコンが使用不可かどうか
  const isQuoteIconDisabled = (icon, item) => {
    switch (icon) {
      case '編集':
      case '削除':
        // 契約済の場合は使用不可
        return contractList?.length > 0;
      case '契約書作成':
      case '変更契約書作成':
        // 承認済でない、または、契約済の場合は使用不可
        return (item.STATUS != '承認済み' && item.STATUS != '小工事') || contractList?.length > 0;
      case '承認申請':
        return (
          item.STATUS == '承認待ち' ||
          item.STATUS == '承認済み' ||
          contractList?.length > 0 ||
          item.STATUS == '小工事'
        );
      case '承認申請取消':
        return item.STATUS != '承認待ち';
      case 'コピー':
        // 契約済の場合はコピー不可
        return contractList?.length > 0;
      case '印刷':
        // 常に使用可能
        return false;
    }
  };

  // ステータスの既読処理
  const handleOnClickStatusLabel = (item) => {
    if (item.APPROVAL_ID) {
      restApi.post(`/api/client/appread/${item.APPROVAL_ID}`, {}, (_) => {
        Object.assign(item, { ...item, APPROVAL_ID: null });
      });
    }
  };

  // 見積一覧のグリッドのフォーマット処理
  const quoteListFormatItem = (grid, e) => {
    if (e.panel.cellType == CellType.Cell) {
      var dataItem = grid.rows[e.row].dataItem;

      // 申請承認画面から呼び出された場合に選択した見積の場合に青くする
      let isUpd = location.state?.quoteNo == dataItem.QUOTE_NO;

      e.cell.style.color = isUpd ? 'blue' : '';
      e.cell.style.fontWeight = isUpd ? 'bold' : '';
      e.cell.style.background = isUpd ? '#DDEEFF' : '';
    }
  };

  return (
    <>
      <Row>
        <Col>
          <div className="list-label1">見積り一覧</div>
        </Col>
        <Col></Col>
        <Row>
          <Col className="mr-3 pt-0 d-flex flex-nowrap text-right align-items-end">
            {contractList?.length > 0 && quoteList.some((x) => x.STATUS != '契約済') ? (
              <label className="mr-2" style={{ fontSize: '14pt', color: 'black' }}>
                <input
                  className="mr-2"
                  style={{ transform: 'scale(1.5)' }}
                  type="checkbox"
                  checked={checkedDisplayNotContract}
                  onChange={() => setCheckedDisplayNotContract(!checkedDisplayNotContract)}
                ></input>
                契約済以外も表示
              </label>
            ) : (
              <></>
            )}
            <Button
              className="material-symbols-rounded cell-icon btn-fill"
              variant="primary"
              onClick={handleOnClickNewQuote}
              disabled={selectedSeikyuNo == -1 || contractList?.length > 0}
              title="見積作成"
            >
              add
            </Button>
          </Col>
        </Row>
      </Row>
      <Row>
        <Col>
          <div className="list-3-line">
            <FlexGrid
              ref={quoteGrid}
              itemsSource={viewQuoteList}
              selectionMode={'None'}
              headersVisibility={'Column'}
              isReadOnly={true}
              loadedRows={(grid) => {
                grid.rows.forEach((ele) => {
                  ele.height = 38;
                });
              }}
              formatItem={quoteListFormatItem}
            >
              <FlexGridColumn binding="NO" header="No" width={60} align={'right'}></FlexGridColumn>
              <FlexGridColumn
                binding="QUOTE_NO"
                header="見積番号"
                format={'d'}
                width={95}
              ></FlexGridColumn>
              <FlexGridColumn binding="MITSU_DATE" header="見積り日" width={95}></FlexGridColumn>
              <FlexGridColumn
                binding="SYANAI_MEI"
                header="工事件名"
                width="*"
                allowResizing={false}
              ></FlexGridColumn>
              <FlexGridColumn
                binding="MITSU_KIN"
                header="金額(税抜)"
                width={100}
                align={'right'}
              ></FlexGridColumn>
              <FlexGridColumn
                binding="MITSU_KIN_ZEI"
                header="金額(税込)"
                width={100}
                align={'right'}
              ></FlexGridColumn>
              <FlexGridColumn binding="STATUS" header="ステータス" width={88} align="center">
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <StatusLableComponent
                      status={cell.item?.STATUS}
                      isUnread={(cell.item?.APPROVAL_ID ?? 0) != 0}
                      rejectReason={cell.item.REJECT_REASON}
                      openRejectCommentModal={approvalRejectCommentModal.openModal}
                      onClick={() => handleOnClickStatusLabel(cell.item)}
                    />
                  )}
                />
              </FlexGridColumn>
              <FlexGridColumn header="" binding="" isReadOnly={true} width={294}>
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <span>
                      <Button
                        className="material-symbols-rounded cell-icon btn-fill"
                        variant="primary"
                        title="編集"
                        onClick={() => handleOnClickEditQuote('upd', cell.item)}
                        disabled={isQuoteIconDisabled('編集', cell.item)}
                      >
                        edit
                      </Button>
                      <Button
                        className="material-symbols-rounded cell-icon btn-fill"
                        variant="danger"
                        title="削除"
                        onClick={() => handleOnClickEditQuote('del', cell.item)}
                        disabled={isQuoteIconDisabled('削除', cell.item)}
                      >
                        delete
                      </Button>
                      <Button
                        className="material-symbols-rounded cell-icon btn-fill"
                        variant={cell.item?.QUOTE_FORMAT_TYPE === 1 ? 'primary' : 'warning'}
                        title={cell.item?.QUOTE_FORMAT_TYPE === 1 ? '印刷(横)' : '印刷(縦)'}
                        onClick={() => handleQuoteAction(cell.item, true)}
                        disabled={isQuoteIconDisabled('印刷', cell.item)}
                      >
                        print
                      </Button>
                      <Button
                        className="material-symbols-rounded cell-icon btn-fill"
                        variant={cell.item?.QUOTE_FORMAT_TYPE === 1 ? 'primary' : 'warning'}
                        title={
                          cell.item?.QUOTE_FORMAT_TYPE === 1
                            ? 'Excelダウンロード(横)'
                            : 'Excelダウンロード(縦)'
                        }
                        onClick={() => handleQuoteAction(cell.item, false)}
                        disabled={isQuoteIconDisabled('ダウンロード', cell.item)}
                      >
                        download
                      </Button>
                      <Button
                        className="material-symbols-rounded cell-icon btn-fill"
                        variant="primary"
                        title="コピー"
                        onClick={() => handleOnClickEditQuote('cpy', cell.item)}
                        disabled={isQuoteIconDisabled('コピー', cell.item)}
                      >
                        file_copy
                      </Button>
                      <Button
                        className="cell-icon btn-fill"
                        variant="primary"
                        title="承認申請"
                        onClick={() => handleOnClickEditQuote('request', cell.item)}
                        disabled={isQuoteIconDisabled('承認申請', cell.item)}
                      >
                        申
                      </Button>
                      <Button
                        className="cell-icon btn-fill"
                        variant="danger"
                        title="承認申請取消"
                        onClick={() => handleOnClickEditQuote('cancel', cell.item)}
                        disabled={isQuoteIconDisabled('承認申請取消', cell.item)}
                      >
                        消
                      </Button>
                      <Button
                        className="cell-icon btn-fill"
                        variant="primary"
                        title="契約書作成"
                        onClick={() => handleOnClickEditContract(cell.item)}
                        disabled={isQuoteIconDisabled('契約書作成', cell.item)}
                      >
                        契
                      </Button>
                    </span>
                  )}
                />
              </FlexGridColumn>
            </FlexGrid>
          </div>
        </Col>
      </Row>
      {/** 見積日選択モーダル */}
      <PrintDateModal params={printDateParams} />
    </>
  );
}

export default QuoteInfo;
